import React, { useState } from 'react';
import { useToast } from '../../Utils/toastContext';


const paymentOptions = [
  { id: 'payid', label: 'Pay with PayID', tag: 'NEW · NO FEES' },
  { id: 'visa', label: 'Visa' },
  { id: 'mastercard', label: 'Mastercard' },
  { id: 'paypal', label: 'PayPal' }
];

const InstantPay = () => {
    const { showToast } = useToast();
  const [selectedMethod, setSelectedMethod] = useState('');
    const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState('AUD');
    const [showGuideline, setShowGuideline] = useState(false);
    const [checkOutUrl, setCheckoutUrl] = useState('');
    const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [isFetchingPayId, setIsFetchingPayId] = useState(false);

    const handleContinue = () => {
    if (selectedMethod !== 'payid') {
      showToast('Please select PayID payment method.', 'error');
      return;
    }

    if (!checkOutUrl) {
      showToast('PayID details are still loading. Please try again.', 'error');
      return;
    }

    setShowCheckoutModal(true);
    showToast('Opening PayID checkout...', 'success');
    };

  const handlePaymentMethodChange = (methodId) => {
    setSelectedMethod(methodId);

    if (methodId === 'payid') {
      fetchPayIdCheckoutUrl();
      return;
    }

    setAmount(0);
    setCurrency('AUD');
    setCheckoutUrl('');
  };


    
    const ADMIN_API_URL = process.env.REACT_APP_REACT_ADMIN || 'https://map.admin.caprock.com.au/';
    const handleResponse = async (response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    };

    const handleError = (error) => {
        console.error('API Error:', error);
    };
    
 

    const fetchPayIdCheckoutUrl = async () => { 
        try { 
        if (isFetchingPayId) {
          return;
        }

        setIsFetchingPayId(true);
            const jwtToken = localStorage.getItem('jwtToken') || '';
            if (!jwtToken) {
                showToast('Session expired. Please sign in again.', 'error');
                return;
            }

            const response = await fetch(`${ADMIN_API_URL}/api/get-payid-request`, {
                method: 'get',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    Accept: 'application/json',
                },
            });
            const data = await handleResponse(response);
            const responseData = data?.data || {};
            const apiAmount = Number(responseData.amount) || 0;
            const baseUrl = responseData.checkOutUrl || responseData.checkoutUrl;

            setAmount(apiAmount);
            setCurrency(responseData.currency || 'AUD');

            if (!baseUrl) {
                showToast('Checkout URL not found in PayID response.', 'error');
                return;
            }

            const separator = baseUrl.includes('?') ? '&' : '?';
            const iframeUrl = `${baseUrl}${separator}type=iframe`;

            setCheckoutUrl(iframeUrl);
            // showToast('PayID details loaded.', 'success');
        } catch (error) {
            handleError(error);
            showToast('Failed to load PayID checkout URL.', 'error');
          } finally {
            setIsFetchingPayId(false);
        }
    }

  return (
    <div className="max-w-2xl mx-auto p-4 sm:p-6">
      <div className="bg-white border border-gray-200 rounded-lg p-5 sm:p-6">
        <h2 className="text-xl font-semibold text-gray-900">Payment Methods</h2>
        <p className="text-sm text-gray-600 mt-1">Choose your payment option.</p>

        <div className="mt-5 space-y-3">
          {paymentOptions.map((option) => (
            <label
              key={option.id}
              className="flex items-center justify-between border border-gray-200 rounded-md px-3 py-3 cursor-pointer hover:border-gray-300"
            >
              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  name="paymentMethod"
                  value={option.id}
                  checked={selectedMethod === option.id}
                  onChange={() => handlePaymentMethodChange(option.id)}
                  className="h-4 w-4"
                />

                {option.id === 'payid' ? (
                  <div className="flex items-center gap-3">
                    <img
                      src="/payid-logo.png"
                      alt="PayID"
                      className="h-8 w-auto object-contain"
                    />
                    <div>
                      <p className="font-medium text-gray-900">{option.label}</p>
                      <p className="text-xs text-blue-700 font-medium">{option.tag}</p>
                    </div>
                  </div>
                ) : (
                  <p className="font-medium text-gray-900">{option.label}</p>
                )}
              </div>

              {option.id === 'payid' && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowGuideline(true);
                  }}
                  className="text-sm text-blue-600 hover:text-blue-800 underline"
                >
                  What is this?
                </button>
              )}
            </label>
          ))}
        </div>

        { amount > 0 && (   
            <>
                <div className="mt-5">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Amount Requested</label>
                    <input
                        disabled
                        type="text"
                      value={`${currency} $${Number(amount).toLocaleString()}`}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />
                </div>
            
            
                <button
                type="button"
                    onClick={handleContinue}
                  className="mt-6 w-full sm:w-auto px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300 disabled:cursor-not-allowed"
                  disabled={selectedMethod !== 'payid' || !checkOutUrl || isFetchingPayId}
                >
                  {isFetchingPayId ? 'Loading...' : 'Continue'}
                </button>
            </>
        )}
      </div>

      {showGuideline && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-5">
            <div className="flex items-start justify-between gap-4">
              <h3 className="text-lg font-semibold text-gray-900">PayID Guidelines</h3>
              <button
                type="button"
                className="text-gray-500 hover:text-gray-700"
                onClick={() => setShowGuideline(false)}
              >
                ✕
              </button>
            </div>

            <div className="mt-4 space-y-5 text-sm text-gray-700"> 
              <div className="border border-gray-200 rounded-md overflow-hidden">
                <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
                  <h4 className="text-xl font-semibold text-gray-800">Get help paying with PayID</h4>
                </div>

                <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between text-gray-700">
                  <span>How do I pay with PayID?</span>
                  <span>⌄</span>
                </div>

                <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between text-gray-700">
                  <span>I didn’t receive a confirmation after payment</span>
                  <span>⌄</span>
                </div>

                <div className="px-4 py-4 bg-gray-50">
                  <div className="flex items-center justify-between">
                    <p className="font-semibold text-gray-800">What is PayID?</p>
                    <span>⌃</span>
                  </div>
                  <p className="mt-3 text-gray-700">
                    PayID is a memorable piece of information such as your mobile number or email address, that you can
                    link to your bank account to receive payments.
                  </p>
                  <p className="mt-3 text-gray-700">
                    Once linked, you can simply provide your PayID for payments instead of handing out your BSB and
                    account number.
                  </p>
                  <p className="mt-3 text-gray-700">
                    If you need to pay someone who has registered for PayID, you’ll only need their PayID to transfer
                    money directly into their bank account.
                  </p>
                </div>
              </div>

              <p className="text-xs text-gray-500">
                PayID is a registered trademark of NPP Australia Limited (NPPA). Use should align with brand guidelines.
              </p>
            </div>
          </div>
        </div>
      )}

      {showCheckoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-3 sm:p-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-5xl h-[85vh] overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900">PayID Checkout</h3>
              <button
                type="button"
                className="text-gray-500 hover:text-gray-700 text-xl leading-none"
                onClick={() => setShowCheckoutModal(false)}
              >
                ✕
              </button>
            </div>

            <div className="w-full h-[calc(85vh-57px)]">
              <iframe
                title="PayID Checkout"
                src={checkOutUrl}
                className="w-full h-full border-0"
                allow="payment *"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InstantPay;
